<app-dialog-crude
  [confirmText]="'RECUSAR'"
  [confirmDisabled]="confirmDisabled"
  (onCancel)="dialogRef.close(null)"
  (onConfirm)="dialogRef.close(reprovationConfirmation)"
>
  <div content>
    <h2 appDialogTitle class="mt-0">Recusar documento</h2>
    <div appDialogContent>
      <app-reprovation
        [preselection]="preselection"
        (setReprovalData)="reprovationChanged($event)"
        (preselectionApplied)="preselectionAppliedChanged($event)"
      ></app-reprovation>
    </div>
  </div>
</app-dialog-crude>
